export enum DealTabs {
    SUMMARY = 'summary',
    TRADE_IN = 'trade-in',
    FEES = 'fees',
    TAXES = 'taxes',
    PROTECTION = 'protection',
    INCENTIVES = 'incentives',
    LENDER = 'lender',
    ACCESSORIES = 'accessories'
}

export enum BreakdownTabsName {
    BREAKDOWN = 'breakdown',
    DEALRECAP = 'deal-recap'
}
export enum BreakdownTabsLabel {
    BREAKDOWN = 'Breakdown',
    DEALRECAP = 'Deal Recap'
}
